module.exports = __webpack_public_path__ + "static/media/icentral-homepage-background-compressed.706656d9.mp4";